import CONFIG from '@/config'
import router from '@/router'
import store from '@/store'
import { getLoginRoute } from '@/utils/routeRedirect'
import { Message } from '@arco-design/web-vue'

const { tokenName } = CONFIG
const BASIC_AUTH_TOKEN = 'Basic aGh4YzpoaHhjcWF6'
let authRedirecting = false

export function setAuthHeader(config) {
  config.headers[tokenName] = store.getters['user/accessToken'] || BASIC_AUTH_TOKEN
  return config
}

export function redirectToLogin() {
  router.replace(getLoginRoute(router.currentRoute.value)).catch(() => {})
}

export function resetAuthAndRedirect(message = '登录失效') {
  if (message) Message.error(message)
  if (authRedirecting) return
  authRedirecting = true
  store.dispatch('user/resetAll').finally(() => {
    redirectToLogin()
    setTimeout(() => {
      authRedirecting = false
    }, 0)
  })
}

export function handleCode(code, message) {
  const normalizedCode = String(code)
  switch (normalizedCode) {
    case '401':
      resetAuthAndRedirect('登录失效')
      break
    case '403':
      router.push({ path: '/401' }).catch(() => {})
      break
    case '500':
      Message.error(message || '未知异常，请联系管理员')
      break
    case 'A0200':
      Message.error(message || '用户登录异常，请联系管理员')
      break
    case 'A0201':
      Message.error(message || '用户不存在')
      break
    case 'A0300':
      Message.error(message || '访问权限异常')
      break
    case 'A0230':
      resetAuthAndRedirect(message || '登录失效')
      break
    case 'A0210':
      Message.error(message || '用户名或密码错误')
      break
    case 'A0211':
      Message.error(message || '用户名输入密码次数超限')
      break
    case 'A0400':
      Message.error(message || '用户请求参数错误')
      break
    case 'A0401':
      Message.error(message || '请求资源不存在')
      break
    case 'C0361':
      Message.error(message)
      break
    default:
      Message.error(`接口异常，code:${code},message:${message}`)
      break
  }
}
